import React from "react";
import {useSelector} from "react-redux";

export const Info = () => {
    const app_lang = useSelector(state => state.app.app_lang)
    const aircategories = useSelector(state => state.app.aircategories)
    const current_category = useSelector(state => state.app.current_category)
    const current_page = useSelector(state => state.app.current_page)
    const showInfo = useSelector(state => state.app.showInfo)

    const change_tag = (text) => {
        let new_text = text;
        let has_symb = true;
        let symb = '**';
        let flag = false;
        while (has_symb) {
            if (new_text.indexOf(symb) + 1 > 0) {
                if (!flag) {
                    new_text = new_text.replace(symb, '<strong>');
                } else {
                    new_text = new_text.replace(symb, '</strong>');
                }
                flag = !flag;
            } else {
                has_symb = false;
            }
        }
        return new_text;
    }
    if (!showInfo) {
        return null;
    }

    if (current_page !== null) {
        let title = current_page.title !== undefined ? current_page.title : '';
        let description = current_page.description !== undefined ? current_page.description : '';
        document.title = current_page.meta_title
        document.querySelector('meta[name="description"]').setAttribute("content", current_page.meta_description);
        return (
            <div className="content-box__info" id="info">
                <div className="content-box__title" dangerouslySetInnerHTML={{__html: title}}/>
                <div className="content-box__description" dangerouslySetInnerHTML={{__html: description}}/>
            </div>
        )
    } else {
        if (current_category === '') {
            let title = '';
            let description = '';
            aircategories.forEach((item) => {
                if (item.fields.locale && item.fields.locale === app_lang) {
                    if (item.fields.id === 0) {
                        title = change_tag(item.fields.title)
                        description = change_tag(item.fields.description)
                        document.title = item.fields.meta_title
                        document.querySelector('meta[name="description"]').setAttribute("content", item.fields.meta_description);

                    }
                }
            })
            if (title !== '' && description !== '') {

                return (
                    <div className="content-box__info" id="info">
                        <div className="content-box__title" dangerouslySetInnerHTML={{__html: title}}/>
                        <div className="content-box__description" dangerouslySetInnerHTML={{__html: description}}/>
                    </div>
                )
            }
        } else {
            let title = '';
            let description = '';
            aircategories.forEach((item) => {
                if (item.fields.locale && item.fields.locale === app_lang) {
                    if (item.fields.slug && item.fields.slug === current_category) {
                        title = change_tag(item.fields.title)
                        description = change_tag(item.fields.description)
                        document.title = item.fields.meta_title
                        document.querySelector('meta[name="description"]').setAttribute("content", item.fields.meta_description);

                    }
                }
            })
            if (title !== '' && description !== '') {

                return (
                    <div className="content-box__info" id="info">
                        <div className="content-box__title" dangerouslySetInnerHTML={{__html: title}}/>
                        <div className="content-box__description" dangerouslySetInnerHTML={{__html: description}}/>
                    </div>
                )
            }
        }
    }
    return null;
}